import { PresentationChartLineIcon } from '@heroicons/react/24/outline';
import { PageHeader } from '../components/PageHeader';
import { ClassificationWeeklyTrends } from '../components/ClassificationWeeklyTrends';
import { useDocumentTitle } from '../hooks/useDocumentTitle';

export default function ClassificationQuality() {
  useDocumentTitle('Classification quality');

  return (
    <div>
      <PageHeader
        title="Classification quality"
        description="Week-on-week mistake rate on labeled pages, model confidence, and related signals"
        icon={<PresentationChartLineIcon className="size-6" />}
      />
      <ClassificationWeeklyTrends />
    </div>
  );
}
